import React from "react";

// core components

function AvailableTreesHeader() {
  let pageHeader = React.createRef();
  React.useEffect(() => {
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });
  return (
    <>
      <div className="page-header page-header-tiny">
        <div
          className="page-header-image"
          style={{
            backgroundImage: "url('https://d11evpdhimy96f.cloudfront.net/cover-shot/available-trees.JPG')"
          }}
          ref={pageHeader}
        ></div>
      </div>
    </>
  );
}

export default AvailableTreesHeader;
